import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { illustrationKeys } from '@/contexts/illustrations';
import { mediaKeys } from '@/contexts/media/queryKeys';

export function registerMediaEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  // Progress is ephemeral — only update videoStatus (for inline spinner),
  // don't invalidate exports query (avoid redundant DB fetches)
  register('media.export.progress', {
    getQueryKeys: (p) => [illustrationKeys.videoStatus(p.jobId as string)],
  });

  register('media.export.completed', {
    getQueryKeys: (p) => [
      illustrationKeys.videoStatus(p.jobId as string),
      illustrationKeys.detail(p.bookId as string),
      ...(p.storyId ? [mediaKeys.exports(p.storyId as string)] : []),
    ],
  });

  register('media.export.failed', {
    getQueryKeys: (p) => [
      illustrationKeys.videoStatus(p.jobId as string),
      ...(p.storyId ? [mediaKeys.exports(p.storyId as string)] : []),
    ],
  });
}
